import { render, staticRenderFns } from "./ApplicantPageV2.vue?vue&type=template&id=217e757f&"
import script from "./ApplicantPageV2.vue?vue&type=script&lang=ts&"
export * from "./ApplicantPageV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('217e757f')) {
      api.createRecord('217e757f', component.options)
    } else {
      api.reload('217e757f', component.options)
    }
    module.hot.accept("./ApplicantPageV2.vue?vue&type=template&id=217e757f&", function () {
      api.rerender('217e757f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Applicant/Details/ApplicantPageV2.vue"
export default component.exports